import PermissionMatrixRow from "@/types/roles/permissionMatrixRow";
import PermissionCategory from "@/types/roles/permissionCategory";

export const permissionMatrix: PermissionMatrixRow[] = [
    {
        name: '@pollux.view.main.user',
        displayName: "View Users",
        description: "Allows users to view all other users in the organization",
        permissions: [
            'pollux.view.main.user',
        ]
    },
    {
        name: '@pollux.view.main.role',
        displayName: "View Roles",
        description: "Allows users to view all roles and permissions available and view roles associated with a team member",
        permissions: [
            'pollux.view.main.role',
            'pollux.view.main.role.permission'
        ]
    },
    {
        name: '@pollux.view.main.organization.integration',
        displayName: "View Organization Integrations",
        description: "Allows the user to view the integrations that are active",
        permissions: [
            'pollux.view.main.organization.setting'
        ]
    },
    {
        name: '@pollux.view.main.invitation',
        displayName: "View Invitations",
        description: "Allows the user to view all outstanding invitations",
        permissions: [
            'pollux.view.main.invitation'
        ]
    },
    {
        name: '@pollux.view.security.magic_link',
        displayName: "View Magic Links",
        description: "Allows the user to view and search for magic links",
        permissions: [
            'pollux.view.security.magic_link'
        ],
        modulePermissions: [[
            'MAGICLINKS',
        ]],
    },
    {
        name: '@pollux.view.main.devapikey',
        displayName: "View Development API Keys",
        description: "Allows the user to view all active API keys",
        permissions: [
            'pollux.view.main.devapikey',
        ],
        modulePermissions: [[
            'LOCATION',
            'SPEEDTEST',
        ]],
    },
    // {
    //     name: '@pollux.view.main.uploaded_file',
    //     displayName: "View Uploaded Files",
    //     description: "Allows the user to view uploaded files",
    //     permissions: [
    //         'pollux.view.main.uploaded_file'
    //     ]
    // },
    // {
    //     name: '@pollux.view.main.notifications',
    //     displayName: "View Organization Level Notifications",
    //     description: "Allows the user to view organization level notifications",
    //     permissions: [
    //         'pollux.view.main.message',
    //         'pollux.view.main.message.submessage',
    //     ]
    // },
    {
        name: '@pollux.view.support_desk.tickets',
        displayName: "View All Support Desk Tickets",
        description: "Allows the user to view all completed and open tickets from the Veducon Support Desk",
        permissions: [
            'pollux.view.support_desk.tickets',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },
    {
        name: '@pollux.view.support_desk.changes',
        displayName: "View All Support Desk Changes",
        description: "Allows the user to view all completed and open changes from the Veducon Support Desk",
        permissions: [
            'pollux.view.support_desk.changes',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },
    {
        name: '@pollux.view.support_desk.service_reports',
        displayName: "View All Service Reports",
        description: "Allows the user to view all service reports issued by the Veducon Manages Services Team",
        permissions: [
            'pollux.view.support_desk.service_reports',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },
    {
        name: '@pollux.manage.support_desk.service_reports',
        displayName: "Add New Service Reports",
        description: "Allows the user to add new service reports issued by the Veducon Manages Services Team",
        permissions: [
            'pollux.create.support_desk.service_reports',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },
    {
        name: '@pollux.delete.support_desk.service_reports',
        displayName: "Delete Service Reports",
        description: "Allows the user to delete service reports issued by the Veducon Manages Services Team",
        permissions: [
            'pollux.delete.support_desk.service_reports',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },
    {
        name: '@pollux.view.support_desk.settings',
        displayName: "View Support Desk Settings",
        description: "Allows the user to view (but not change) the support desk ticket tab settings",
        permissions: [
            'pollux.view.support_desk.settings',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },
    {
        name: '@pollux.manage.support_desk.settings',
        displayName: "Manage Support Desk Settings",
        description: "Allows the user to configure support desk ticket tabs, such as the requester e-mail suffix tab",
        permissions: [
            'pollux.view.support_desk.settings',
            'pollux.update.support_desk.settings',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },
    {
        name: '@pollux.view.meraki.internet_connections',
        displayName: "View Meraki Internet Connections",
        description: "Allows the user to view all troubled and failed internet connections",
        permissions: [
            'pollux.view.meraki.internet_connections',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.cellular_backup',
        displayName: "View Meraki Cellular Backups",
        description: "Allows the user to view all Meraki celullar backup connections",
        permissions: [
            'pollux.view.meraki.cellular_backup',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_CELLULAR_BACKUP',
        ]],
    },
    {
        name: '@pollux.view.meraki.subnet',
        displayName: "View Meraki Subnets",
        description: "Allows the user to view all Meraki subnets",
        permissions: [
            'pollux.view.meraki.network.vlan',
            'pollux.view.meraki.subnet',
            'pollux.view.ipam_blueprint.network_range',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.camera.snapshot',
        displayName: "View Meraki Camera Snapshot",
        description: "Allows the user to view a snapshot of a security camera. Additionally this allows the user to see an overview of all security cameras",
        permissions: [
            'pollux.view.meraki.camera.snapshot',
            'pollux.view.meraki.device.camera'
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_CAMERA_SNAPSHOT',
        ]],
    },
    {
        name: '@pollux.view.meraki.internet_connections',
        displayName: "View Meraki Internet Connections",
        description: "Allows the user to view all troubled and failed internet connections",
        permissions: [
            'pollux.view.meraki.internet_connections',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.client',
        displayName: "View Meraki Clients",
        description: "Allows the user to view all Meraki clients",
        permissions: [
            'pollux.view.meraki.client',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_CLIENTS',
        ]],
    },
    {
        name: '@pollux.view.meraki.switchports',
        displayName: "View Switchport Templates",
        description: "Allows the user to view the Switchport Templates",
        permissions: [
            'pollux.view.meraki.switchports',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_SWITCHPORTS',
        ]],
    },
    {
        name: '@pollux.view.meraki.mxports',
        displayName: "View MX port Templates",
        description: "Allows the user to view the MX port Templates",
        permissions: [
            'pollux.view.meraki.mxports',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_MXPORTS',
        ]],
    },
    {
        name: '@pollux.view.meraki.mx.inspect.static',
        displayName: "Inspect MX Static Port Config",
        description: "Allows the user to view static MX appliance port configuration (port number, VLAN, type) and the WAN uplink status.",
        permissions: [
            'pollux.view.meraki.mx.inspect.static',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_MX_INSPECT_STATIC',
        ]],
    },
    {
        name: '@pollux.view.meraki.mx.inspect.live',
        displayName: "Inspect MX Live Status",
        description: "Allows the user to view live MX port status via the beta liveTools job. Requires the static inspect permission.",
        // Static is listed first so .every() on hasUserPermission enforces the dependency.
        permissions: [
            'pollux.view.meraki.mx.inspect.static',
            'pollux.view.meraki.mx.inspect.live',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_MX_INSPECT_STATIC',
            'MERAKI_MX_INSPECT_LIVE',
        ]],
    },
    {
        name: '@pollux.manage.meraki.mx',
        displayName: "MX Port Cycle",
        description: "Allows the user to cycle (disable and re-enable) MX appliance ports. MX port configuration itself stays read-only. Requires the static inspect permission.",
        permissions: [
            'pollux.view.meraki.mx.inspect.static',
            'pollux.edit.meraki.mx',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_MX_INSPECT_STATIC',
            'MERAKI_MX_EDIT',
        ]],
    },
    {
        name: '@pollux.view.meraki.device.all',
        displayName: "View All Meraki Devices",
        description: "Allows the user to view all Meraki devices. This also allows the user to view the Meraki Networks.",
        permissions: [
            'pollux.view.meraki.device.all',
            'pollux.view.meraki.device.router',
            'pollux.view.meraki.device.switch',
            'pollux.view.meraki.device.wireless_lan',
            'pollux.view.meraki.device.sensor',
            'pollux.view.meraki.device.cellular_gateway',
            'pollux.view.meraki.device.camera',
            'pollux.view.meraki.device.status',
            'pollux.view.meraki.device.type',
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.device.router',
        displayName: "View Meraki MX Devices",
        description: "Allows the user to view all MX Meraki devices. This also allows the user to view the Meraki Networks.",
        permissions: [
            'pollux.view.meraki.device.router',
            'pollux.view.meraki.device.status',
            'pollux.view.meraki.device.type',
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.device.switch',
        displayName: "View Meraki MS Devices",
        description: "Allows the user to view all MS Meraki devices. This also allows the user to view the Meraki Networks.",
        permissions: [
            'pollux.view.meraki.device.switch',
            'pollux.view.meraki.device.status',
            'pollux.view.meraki.device.type',
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.device.wireless_lan',
        displayName: "View Meraki MR Devices",
        description: "Allows the user to view all MR Meraki devices. This also allows the user to view the Meraki Networks.",
        permissions: [
            'pollux.view.meraki.device.wireless_lan',
            'pollux.view.meraki.device.status',
            'pollux.view.meraki.device.type',
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.device.sensor',
        displayName: "View Meraki MS Devices",
        description: "Allows the user to view all MT Meraki devices. This also allows the user to view the Meraki Networks.",
        permissions: [
            'pollux.view.meraki.device.sensor',
            'pollux.view.meraki.device.status',
            'pollux.view.meraki.device.type',
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.device.cellular_gateway',
        displayName: "View Meraki MG Devices",
        description: "Allows the user to view all MG Meraki devices. This also allows the user to view the Meraki Networks.",
        permissions: [
            'pollux.view.meraki.device.cellular_gateway',
            'pollux.view.meraki.device.status',
            'pollux.view.meraki.device.type',
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.device.camera',
        displayName: "View Meraki MV Devices",
        description: "Allows the user to view all MV Meraki devices. This also allows the user to view the Meraki Networks.",
        permissions: [
            'pollux.view.meraki.device.camera',
            'pollux.view.meraki.device.status',
            'pollux.view.meraki.device.type',
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.reboot.meraki.device.all',
        displayName: "Reboot All Meraki Devices",
        description: "Allows the user to reboot all Meraki devices",
        permissions: [
            'pollux.reboot.meraki.device.all',
            'pollux.reboot.meraki.device.router',
            'pollux.reboot.meraki.device.switch',
            'pollux.reboot.meraki.device.wireless_lan',
            'pollux.reboot.meraki.device.sensor',
            'pollux.reboot.meraki.device.cellular_gateway',
            'pollux.reboot.meraki.device.camera',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
            'MERAKI_DEVICE_REBOOT:UPDATE'
        ]],
    },
    {
        name: '@pollux.reboot.meraki.device.router',
        displayName: "Reboot Meraki MX Devices",
        description: "Allows the user to reboot all MX Meraki devices",
        permissions: [
            'pollux.reboot.meraki.device.router',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
            'MERAKI_DEVICE_REBOOT:UPDATE'
        ]],
    },
    {
        name: '@pollux.reboot.meraki.device.switch',
        displayName: "Reboot Meraki MS Devices",
        description: "Allows the user to reboot all MS Meraki devices",
        permissions: [
            'pollux.reboot.meraki.device.switch',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
            'MERAKI_DEVICE_REBOOT:UPDATE'
        ]],
    },
    {
        name: '@pollux.reboot.meraki.device.wireless_lan',
        displayName: "Reboot Meraki MR Devices",
        description: "Allows the user to reboot all MR Meraki devices",
        permissions: [
            'pollux.reboot.meraki.device.wireless_lan',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
            'MERAKI_DEVICE_REBOOT:UPDATE'
        ]],
    },
    {
        name: '@pollux.reboot.meraki.device.sensor',
        displayName: "Reboot Meraki MS Devices",
        description: "Allows the user to reboot all MS Meraki devices",
        permissions: [
            'pollux.reboot.meraki.device.sensor',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
            'MERAKI_DEVICE_REBOOT:UPDATE'
        ]],
    },
    {
        name: '@pollux.reboot.meraki.device.cellular_gateway',
        displayName: "Reboot Meraki MG Devices",
        description: "Allows the user to reboot all MG Meraki devices",
        permissions: [
            'pollux.reboot.meraki.device.cellular_gateway',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
            'MERAKI_DEVICE_REBOOT:UPDATE'
        ]],
    },
    {
        name: '@pollux.reboot.meraki.device.camera',
        displayName: "Reboot Meraki MV Devices",
        description: "Allows the user to reboot all MV Meraki devices",
        permissions: [
            'pollux.reboot.meraki.device.camera',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
            'MERAKI_DEVICE_REBOOT:UPDATE'
        ]],
    },
    {
        name: '@pollux.export.meraki.devices_per_contract',
        displayName: "Export Devices per Contract",
        description: "Allows the user to export the Devices per Contract overview",
        permissions: [
            'pollux.export.meraki.devices_per_contract',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.network',
        displayName: "View Meraki Networks",
        description: "Allows the user to view all Meraki networks",
        permissions: [
            'pollux.view.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.network.vlan',
        displayName: "View Meraki Network VLANs",
        description: "Allows the user to view all Meraki VLANS of a Network",
        permissions: [
            'pollux.view.meraki.network.vlan',
            'pollux.view.ipam_blueprint.network_range',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.view.meraki.network.fixed_ip_assignment',
        displayName: "View Meraki Network Fixed IP Assignments",
        description: "Allows the user to view Meraki fixed ip assignments per network",
        permissions: [
            'pollux.view.meraki.network.vlan',
            'pollux.view.ipam_blueprint.network_range',
            'pollux.view.meraki.network.fixed_ip_assignment',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.manage.meraki.network.fixed_ip_assignment',
        displayName: "Manage Meraki Fixed IP Assignments",
        description: "Allows the user to add and update new fixed IP assignments to a VLAN",
        permissions: [
            'pollux.view.meraki.network.vlan',
            'pollux.view.ipam_blueprint.network_range',
            'pollux.view.meraki.network.fixed_ip_assignment',
            'pollux.create.meraki.network.fixed_ip_assignment',
            'pollux.update.meraki.network.fixed_ip_assignment',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.delete.meraki.network.fixed_ip_assignment',
        displayName: "Delete Meraki Fixed IP Assignments",
        description: "Allows the user to remove a fixed IP assignment from a VLAN",
        permissions: [
            'pollux.view.meraki.network.vlan',
            'pollux.view.ipam_blueprint.network_range',
            'pollux.view.meraki.network.fixed_ip_assignment',
            'pollux.delete.meraki.network.fixed_ip_assignment',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:DELETE',
        ]],
    },
    {
        name: '@pollux.view.meraki.vpn_status',
        displayName: "View Meraki VPN Statusses",
        description: "Allows the user to view all Meraki vpn statusses",
        permissions: [
            'pollux.view.meraki.vpn_status',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'VPN_STATUS',
        ]],
    },
    {
        name: '@pollux.view.location.overview',
        displayName: "View Overview of All Locations",
        description: "Allows the user to view all locations",
        permissions: [
            'pollux.view.location.overview',
            'pollux.view.location.branch',
            'pollux.view.location.type',
            'pollux.view.location.tag',
            'pollux.view.location.contact_details',
            'pollux.view.geo.timezones.city',
            'pollux.view.geo.timezones.country',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_BRANCH',
            'LOCATION_TYPE',
        ]],
    },
    {
        name: '@pollux.view.location.branch',
        displayName: "View Location Branches",
        description: "Allows the user to view all location branches",
        permissions: [
            'pollux.view.location.branch',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_BRANCH',
        ]],
    },
    {
        name: '@pollux.view.location.type',
        displayName: "View Location Types",
        description: "Allows the user to view all location types",
        permissions: [
            'pollux.view.location.type',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_TYPE',
        ]],
    },
    {
        name: '@pollux.view.location.documentation',
        displayName: "View Location Documentation",
        description: "Allows the user to view all location documentation",
        permissions: [
            'pollux.view.location.documentation',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_DOCUMENTATION',
        ]],
    },
    {
        name: '@pollux.view.location.speedtest',
        displayName: "View Location Speedtests",
        description: "Allows the user to view all location speedtests",
        permissions: [
            'pollux.view.location.speedtest',
        ],
        modulePermissions: [[
            'LOCATION',
            'SPEEDTEST',
        ]],
    },
    {
        name: '@pollux.view.ipam_blueprint.network_range',
        displayName: "View Network Ranges",
        description: "Allows the user to view all network ranges",
        permissions: [
            'pollux.view.ipam_blueprint.network_range',
        ],
        modulePermissions: [[
            'BLUEPRINTS',
        ]],
    },
    {
        name: '@pollux.view.ipam_blueprint.vlan_rule',
        displayName: "View VLAN Rules",
        description: "Allows the user to view all vlan rules",
        permissions: [
            'pollux.view.ipam_blueprint.vlan_rule',
        ],
        modulePermissions: [[
            'BLUEPRINTS',
        ]],
    },
    {
        name: '@pollux.view.ipam_blueprint.vlan_rule_action',
        displayName: "View VLAN Rule Actions",
        description: "Allows the user to view all vlan rule actions",
        permissions: [
            'pollux.view.ipam_blueprint.vlan_rule_action',
        ],
        modulePermissions: [[
            'BLUEPRINTS',
        ]],
    },
    {
        name: '@pollux.view.rms.cellular_backup',
        displayName: "View RMS Cellular Backup",
        description: "Allows the user to view all cellular backups managed by RMS",
        permissions: [
            'pollux.view.rms.cellular_backup',
        ],
        modulePermissions: [[
            'RMS_MAIN',
        ]],
    },
    {
        name: '@pollux.view.external_tools.sim_cards',
        displayName: "View SIM cards",
        description: "Allows the user to view all sim cards",
        permissions: [
            'pollux.view.external_tools.sim_cards',
        ],
        modulePermissions: [[
            'MODULE_EXT_TOOLS_SIM_CARDS',
        ]],
    },
    {
        name: '@pollux.view.documentation.procedures',
        displayName: "View Procedures Documentation",
        description: "Allows the user to view all procedures documentation",
        permissions: [
            'pollux.view.documentation.procedures',
        ],
        modulePermissions: [[
            'PROCEDURE_DOCUMENTATION',
        ]],
    },
    {
        name: '@pollux.manage.documentation.procedures',
        displayName: "Manage Procedures Documentation",
        description: "Allows the user to create and manage procedures documentation",
        permissions: [
            'pollux.create.documentation.procedures',
        ],
        modulePermissions: [[
            'PROCEDURE_DOCUMENTATION:CREATE',
        ]],
    },
    {
        name: '@pollux.delete.documentation.procedures',
        displayName: "Delete Procedures Documentation",
        description: "Allows the user to delete procedure documentation",
        permissions: [
            'pollux.delete.documentation.procedures',
        ],
        modulePermissions: [[
            'PROCEDURE_DOCUMENTATION:DELETE',
        ]],
    },
    {
        name: '@pollux.view.ipam',
        displayName: "View IPAM Overview",
        description: "Allows the user to view IPAM overview",
        permissions: [
            'pollux.view.ipam',
        ],
        modulePermissions: [[
            'MERAKI_IPAM',
        ]],
    },
    {
        name: '@pollux.view.verkada.cameras',
        displayName: "View Verkada Cameras",
        description: "Allows the user to view Verkada cameras",
        permissions: [
            'pollux.view.verkada.cameras',
        ],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_CAMERA'
        ]],
    },
    {
        name: '@pollux.view.verkada.access',
        displayName: "View Verkada Access Devices",
        description: "Allows the user to view Verkada access devices",
        permissions: [
            'pollux.view.verkada.access',
        ],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_ACCESS'
        ]],
    },
    {
        name: '@pollux.view.verkada.sites',
        displayName: "View Verkada Sites",
        description: "Allows the user to view Verkada sites",
        permissions: [
            'pollux.view.verkada.sites',
        ],
        modulePermissions: [[
            'VERKADA_MAIN',
        ]],
    },
    {
        name: '@pollux.view.wyebot.sites',
        displayName: "View Wyebot Sites",
        description: "Allows the user to view Wyebot sites",
        permissions: [
            'pollux.view.wyebot.sites',
        ],
        modulePermissions: [[
            'WYEBOT_MAIN',
        ]],
    },
    {
        name: '@pollux.view.wyebot.sensors',
        displayName: "View Wyebot Sensors",
        description: "Allows the user to view Wyebot sensors",
        permissions: [
            'pollux.view.wyebot.sensors',
        ],
        modulePermissions: [[
            'WYEBOT_MAIN',
            'WYEBOT_SENSORS',
        ]],
    },
    {
        name: '@pollux.view.wyebot.tests',
        displayName: "View Wyebot Tests",
        description: "Allows the user to view Wyebot tests",
        permissions: [
            'pollux.view.wyebot.tests',
        ],
        modulePermissions: [[
            'WYEBOT_MAIN',
            'WYEBOT_TESTS',
        ]],
    },


    {
        name: '@pollux.manage.main.user',
        displayName: "Manage Users",
        description: "Allows the user to change all details of other users except their role and password",
        permissions: [
            'pollux.create.main.user',
            'pollux.update.main.user',
        ]
    },
    {
        name: '@pollux.manage.main.user.self',
        displayName: "Manage Own Profile",
        description: "Allows the user to change their own profile",
        permissions: [
            'pollux.update.main.user.self',
        ]
    },
    {
        name: '@pollux.manage.main.user.password',
        displayName: "Manage Users Passwords (ADMINISTRATORS ONLY)",
        description: "CAUTION: Allows the user to change the passwords of other users. Only give this to people you trust.",
        permissions: [
            'pollux.update.main.user.password',
        ]
    },
    {
        name: '@pollux.manage.main.user.role',
        displayName: "Manage Users Roles (ADMINISTRATORS ONLY)",
        description: "CAUTION: Allows the user to change the roles of other users. Only give this to people you trust.",
        permissions: [
            'pollux.update.main.user.role',
        ]
    },
    {
        name: '@pollux.manage.main.role',
        displayName: "Manage Roles (ADMINISTRATORS ONLY)",
        description: "CAUTION: Allows the user to update the role of all users except themselves. Additionally this allows the user to create new roles. Only give this to people you trust.",
        permissions: [
            'pollux.create.main.role',
            'pollux.update.main.role',
        ]
    },
    {
        name: '@pollux.manage.main.organization.branding',
        displayName: "Manage Organization Branding",
        description: "Allows the user to change the organization branding",
        permissions: [
            'pollux.update.main.organization.branding',
        ]
    },
    {
        name: '@pollux.manage.main.organization.it_management',
        displayName: "Manage Organization IT Management",
        description: "Allows the user to change the organization IT management, such as: Preferred login method, IT manager e-mail and IT manager password. This does not include the ability to change other users passwords!",
        permissions: [
            'pollux.update.main.organization.it_management',
        ]
    },
    {
        name: '@pollux.manage.main.invitation',
        displayName: "Manage User Invitations",
        description: "Allows the user to invite people to the organization",
        permissions: [
            'pollux.create.main.invitation',
        ]
    },
    {
        name: '@pollux.manage.security.magic_link',
        displayName: "Manage Magic Links",
        description: "Allows the user to create, update and delete magic links",
        permissions: [
            'pollux.create.security.magic_link',
            'pollux.view.security.magic_link',
            'pollux.update.security.magic_link',
            'pollux.delete.security.magic_link',
        ],
        modulePermissions: [[
            'MAGICLINKS',
        ]],
    },
    {
        name: '@pollux.manage.main.devapikey',
        displayName: "Manage Development API Keys",
        description: "Allows the user to manage all active API keys",
        permissions: [
            'pollux.update.main.devapikey',
            'pollux.create.main.devapikey',
        ],
        modulePermissions: [[
            'LOCATION',
            'SPEEDTEST',
        ]],
    },
    {
        name: '@pollux.manage.main.organization.integration',
        displayName: "Manage Organization Integrations",
        description: "Allows the user to manage the integrations that are active and edit and remove integration credentials",
        permissions: [
            'pollux.create.main.organization.setting',
            'pollux.update.main.organization.setting'
        ]
    },
    {
        name: '@pollux.manage.main.organization.strategy.network.naming',
        displayName: "Manage Organization Network Naming Strategy",
        description: "Allows the user to view and manage the organization network naming strategy",
        permissions: [
            'pollux.view.main.organization.strategy.network.naming',
            'pollux.update.main.organization.strategy.network.naming'
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
        ]],
    },
    {
        name: '@pollux.manage.main.organization.strategy.location.naming',
        displayName: "Manage Organization Location Naming Strategy",
        description: "Allows the user to view and manage the organization location naming strategy",
        permissions: [
            'pollux.view.main.organization.strategy.location.naming',
            'pollux.update.main.organization.strategy.location.naming'
        ],
        modulePermissions: [[
            'LOCATION',
        ]],
    },

    {
        name: '@pollux.reply.support_desk.tickets',
        displayName: "Reply to Servicedesk Tickets",
        description: "Allows the user to reply to all servicedesk tickets",
        permissions: [
            'pollux.reply.support_desk.tickets',
        ],
        modulePermissions: [[
            'LOCATION',
        ]],
    },
    {
        name: '@pollux.reply.support_desk.changes',
        displayName: "Reply to Servicedesk Changes",
        description: "Allows the user to reply to all servicedesk changes",
        permissions: [
            'pollux.reply.support_desk.changes',
        ],
        modulePermissions: [[
            'SUPPORT_DESK',
            'SUPPORT_DESK_TICKETS'
        ]],
    },

    {
        name: '@pollux.create.location.refit.phase_2',
        displayName: "Refit Phase 2",
        description: "Allows the user to start refit Phase 2",
        permissions: [
            'pollux.create.location.refit.phase_2',
        ],
        modulePermissions: [[
            'LOCATION:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.create.location.refit.prestage',
        displayName: "Prestage refit Locations",
        description: "Allows the user to prestage refit locations",
        permissions: [
            'pollux.create.location.refit.prestage',
        ],
        modulePermissions: [[
            'LOCATION:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.location.location',
        displayName: "Manage Locations",
        description: "Allows the user to change locations and to create new locations. Additionally, this enables the ability to view branches and types.",
        permissions: [
            'pollux.create.location.location',
            'pollux.create.location.tag',
            'pollux.view.location.branch',
            'pollux.view.location.type',
            'pollux.update.location.location',
            'pollux.update.location.tag',
            'pollux.update.location.contact_details'
        ],
        modulePermissions: [[
            'LOCATION:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.import.location.location',
        displayName: "Import Locations",
        description: "Allows the user to bulk import locations and to create these new locations",
        permissions: [
            'pollux.create.location.import',
        ],
        modulePermissions: [[
            'LOCATION:CREATE',
        ]],
    },
    {
        name: '@pollux.manage.location.branch',
        displayName: "Manage Location Branches",
        description: "Allows the user to change location branches, transfer location branches and to create new location branches",
        permissions: [
            'pollux.create.location.branch',
            'pollux.update.location.branch',
            'pollux.transfer.location.branch',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_BRANCH:CREATE,UPDATE'
        ]],
    },
    {
        name: '@pollux.manage.location.type',
        displayName: "Manage Location Types",
        description: "Allows the user to change location types, transfer location types and to create new location types",
        permissions: [
            'pollux.create.location.type',
            'pollux.update.location.type',
            'pollux.transfer.location.type',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_TYPE:CREATE,UPDATE'
        ]],
    },
    {
        name: '@pollux.manage.location.documentation',
        displayName: "Create/Upload Location Documentation",
        description: "Allows the user to upload new location documentation and view an overview of all locations",
        permissions: [
            'pollux.create.location.documentation',
            'pollux.view.location.overview',
            'pollux.view.location.tag',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_DOCUMENTATION:CREATE'
        ]],
    },
    // {
    //     name: '@pollux.manage.location.speedtest',
    //     displayName: "Start Location Speedtests",
    //     description: "Allows the user to create a new speedtest",
    //     permissions: [
    //         'pollux.create.location.speedtest',
    //     ],
    //     modulePermissions: [[
    //         'LOCATION',
    //         'SPEEDTEST:CREATE,UPDATE'
    //     ]],
    // },

    {
        name: '@pollux.manage.meraki.camera.request_footage',
        displayName: "Make a request to access live camera footage",
        description: "Allows the user to make a request to view live camera footage",
        permissions: [
            'pollux.create.meraki.camera.request_footage',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_CAMERA_ACCESS:UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.meraki.guest_wifi',
        displayName: "Manage Guest Wi-Fi",
        description: "Allows the user to enable and disable guest Wi-Fi per network",
        permissions: [
            'pollux.update.meraki.guest_wifi',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_GUEST_WIFI:UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.meraki.settings.guest_wifi',
        displayName: "Manage Guest Wi-Fi Settings",
        description: "Allows the user to enable and disable guest Wi-Fi settings, like the SSID tag to be set on all access points.",
        permissions: [
            'pollux.update.meraki.settings.guest_wifi',
        ],
        modulePermissions: [[
            'MERAKI_MAIN',
            'MERAKI_GUEST_WIFI:UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.meraki.network',
        displayName: "Manage Meraki Networks",
        description: "Allows the user to update Meraki network details",
        permissions: [
            'pollux.create.meraki.network',
            'pollux.create.meraki.network.vlan',
            'pollux.update.meraki.network',
            'pollux.update.meraki.network.vlan',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.meraki.subnet',
        displayName: "Import Meraki Subnets",
        description: "Allows the user import Meraki subnets",
        permissions: [
            'pollux.create.meraki.subnet',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:CREATE',
        ]],
    },
    {
        name: '@pollux.manage.ipam_blueprint.network_range',
        displayName: "Manage Network Ranges",
        description: "Allows the user to create and change network ranges",
        permissions: [
            'pollux.create.ipam_blueprint.network_range',
            'pollux.update.ipam_blueprint.network_range',
        ],
        modulePermissions: [[
            'BLUEPRINTS:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.ipam_blueprint.vlan_rule',
        displayName: "Manage VLAN Rules",
        description: "Allows the user to create and change vlan rules",
        permissions: [
            'pollux.create.ipam_blueprint.vlan_rule',
            'pollux.update.ipam_blueprint.vlan_rule',
        ],
        modulePermissions: [[
            'BLUEPRINTS:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.ipam_blueprint.vlan_rule_action',
        displayName: "Manage VLAN Rule Actions",
        description: "Allows the user to create and change vlan rule actions",
        permissions: [
            'pollux.create.ipam_blueprint.vlan_rule_action',
            'pollux.update.ipam_blueprint.vlan_rule_action',
        ],
        modulePermissions: [[
            'BLUEPRINTS:CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.external_tools.sim_cards.notes',
        displayName: "Manage SIM cards notes",
        description: "Allows the user to manage all notes on sim cards",
        permissions: [
            'pollux.create.external_tools.sim_cards.notes',
            'pollux.update.external_tools.sim_cards.notes',
        ],
        modulePermissions: [[
            'MODULE_EXT_TOOLS_SIM_CARDS',
        ]],
    },
    {
        name: '@pollux.manage.verkada.cameras.footage_request',
        displayName: "Create Verkada Camera Footage Request",
        description: "Allows the user to create a request to view Verkada camera footage. This request must be authorized by an authorizing party.",
        permissions: [
            'pollux.create.verkada.cameras.footage_request',
        ],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_CAMERA',
            'VERKADA_CAMERA_ACCESS',
        ]],
    },
    {
        name: '@pollux.manage.verkada.cameras.snapshot',
        displayName: "Create Verkada Camera Snapshot",
        description: "Allows the user to create a snapshot of a Verkada camera.",
        permissions: [
            'pollux.create.verkada.cameras.snapshot',
        ],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_CAMERA',
            'VERKADA_CAMERA_SNAPSHOT',
        ]],
    },
    {
        name: '@pollux.manage.verkada.access',
        displayName: "Control Verkada Access Devices",
        description: "Allows the user to control Verkada access devices. Eg. open a door or a rack.",
        permissions: [
            'pollux.control.verkada.access',
        ],
        modulePermissions: [[
            'VERKADA_MAIN',
            'VERKADA_ACCESS:LIST,UPDATE'
        ]],
    },
    {
        name: '@pollux.manage.verkada.sites',
        displayName: "Connect Verkada Sites",
        description: "Allows the user to bind Verkada sites to Pollux locations",
        permissions: [
            'pollux.bind.verkada.sites',
        ],
        modulePermissions: [[
            'VERKADA_MAIN:LIST,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.wyebot.sites',
        displayName: "Connect Wyebot Sites",
        description: "Allows the user to bind Wyebot sites to Pollux locations",
        permissions: [
            'pollux.view.wyebot.sites',
            'pollux.bind.wyebot.sites',
            'pollux.view.location.overview',
            'pollux.view.location.tag',
            'pollux.view.location.contact_details',
            'pollux.view.geo.timezones.city',
            'pollux.view.geo.timezones.country',
            'pollux.create.location.location',
            'pollux.create.location.tag',
            'pollux.view.location.branch',
            'pollux.view.location.type',
            'pollux.update.location.location',
            'pollux.update.location.tag',
            'pollux.update.location.contact_details'
        ],
        modulePermissions: [[
            'WYEBOT_MAIN:LIST,UPDATE',
            'LOCATION:LIST,CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.wyebot.sensors',
        displayName: "Connect Wyebot Sensors",
        description: "Allows the user to bind Wyebot sensors to Pollux locations",
        permissions: [
            'pollux.view.wyebot.sensors',
            'pollux.bind.wyebot.sensors',
            'pollux.view.location.overview',
            'pollux.view.location.tag',
            'pollux.view.location.contact_details',
            'pollux.view.geo.timezones.city',
            'pollux.view.geo.timezones.country',
            'pollux.create.location.location',
            'pollux.create.location.tag',
            'pollux.view.location.branch',
            'pollux.view.location.type',
            'pollux.update.location.location',
            'pollux.update.location.tag',
            'pollux.update.location.contact_details'
        ],
        modulePermissions: [[
            'WYEBOT_MAIN',
            'WYEBOT_SENSORS:LIST,UPDATE',
            'LOCATION:LIST,CREATE,UPDATE',
        ]],
    },
    {
        name: '@pollux.manage.wyebot.tests',
        displayName: "Manage Wyebot Tests",
        description: "Allows the user to manage Wyebot tests",
        permissions: [
            'pollux.view.wyebot.tests',
            'pollux.create.wyebot.tests',
        ],
        modulePermissions: [[
            'WYEBOT_MAIN',
            'WYEBOT_TESTS:LIST,CREATE,UPDATE',
        ]],
    },



    {
        name: '@pollux.delete.main.user',
        displayName: "Delete Users",
        description: "Allows the user to delete other users",
        permissions: [
            'pollux.delete.main.user',
        ]
    },
    {
        name: '@pollux.delete.main.invitation',
        displayName: "Delete Invitations",
        description: "Allows the user to withdraw/delete invitations",
        permissions: [
            'pollux.delete.main.invitation',
        ]
    },
    {
        name: '@pollux.delete.main.role',
        displayName: "Delete Roles (ADMINISTRATORS ONLY)",
        description: "Caution: Allows the user to delete other roles. Only give this to people you trust.",
        permissions: [
            'pollux.delete.main.role',
        ]
    },
    {
        name: '@pollux.delete.main.devapikey',
        displayName: "Delete Development API Keys",
        description: "Allows the user to delete active API keys",
        permissions: [
            'pollux.delete.main.devapikey',
        ],
        modulePermissions: [[
            'LOCATION',
            'SPEEDTEST',
        ]],
    },
    {
        name: '@pollux.delete.location.location',
        displayName: "Delete Location",
        description: "Allows the user to delete locations",
        permissions: [
            'pollux.delete.location.location',
        ],
        modulePermissions: [[
            'LOCATION:DELETE'
        ]]
    },
    {
        name: '@pollux.delete.location.branch',
        displayName: "Delete Location Branches",
        description: "Allows the user to delete location branches",
        permissions: [
            'pollux.delete.location.branch',
        ],
        modulePermissions: [[
            'LOCATION_BRANCH:DELETE'
        ]]
    },
    {
        name: '@pollux.delete.location.type',
        displayName: "Delete Location Types",
        description: "Allows the user to delete location types",
        permissions: [
            'pollux.delete.location.type',
        ],
        modulePermissions: [[
            'LOCATION_TYPE:DELETE'
        ]]
    },
    {
        name: '@pollux.delete.location.documentation',
        displayName: "Delete Location Documentation",
        description: "Allows the user to delete existing location documentation",
        permissions: [
            'pollux.delete.location.documentation',
        ],
        modulePermissions: [[
            'LOCATION',
            'LOCATION_DOCUMENTATION:DELETE'
        ]],
    },
    {
        name: '@pollux.delete.ipam_blueprint.network_range',
        displayName: "Delete Network Ranges",
        description: "Allows the user to delete network ranges",
        permissions: [
            'pollux.delete.ipam_blueprint.network_range',
        ],
        modulePermissions: [[
            'BLUEPRINTS:DELETE',
        ]],
    },
    {
        name: '@pollux.delete.ipam_blueprint.vlan_rule',
        displayName: "Delete VLAN Rules",
        description: "Allows the user to delete vlan rules",
        permissions: [
            'pollux.delete.ipam_blueprint.vlan_rule',
        ],
        modulePermissions: [[
            'BLUEPRINTS:DELETE',
        ]],
    },
    {
        name: '@pollux.delete.ipam_blueprint.vlan_rule_action',
        displayName: "Delete VLAN Rule Actions",
        description: "Allows the user to delete vlan rule actions",
        permissions: [
            'pollux.delete.ipam_blueprint.vlan_rule_action',
        ],
        modulePermissions: [[
            'BLUEPRINTS:DELETE',
        ]],
    },
    {
        name: '@pollux.delete.meraki.network',
        displayName: "Delete Meraki Networks",
        description: "Allows the user to delete Meraki networks",
        permissions: [
            'pollux.delete.meraki.network',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:DELETE',
        ]],
    },
    {
        name: '@pollux.delete.external_tools.sim_cards',
        displayName: "Delete SIM cards",
        description: "Allows the user to delete all sim cards",
        permissions: [
            'pollux.delete.external_tools.sim_cards',
        ],
        modulePermissions: [[
            'MODULE_EXT_TOOLS_SIM_CARDS',
        ]],
    },
    {
        name: '@pollux.delete.external_tools.sim_cards.notes',
        displayName: "Delete SIM cards notes",
        description: "Allows the user to delete all notes on sim cards",
        permissions: [
            'pollux.delete.external_tools.sim_cards.notes',
        ],
        modulePermissions: [[
            'MODULE_EXT_TOOLS_SIM_CARDS',
        ]],
    },
    {
        name: '@pollux.delete.wyebot.tests',
        displayName: "Delete Wyebot Tests",
        description: "Allows the user to delete Wyebot tests",
        permissions: [
            'pollux.view.wyebot.tests',
            'pollux.delete.wyebot.tests',
        ],
        modulePermissions: [[
            'WYEBOT_MAIN',
            'WYEBOT_TESTS:LIST,DELETE',
        ]],
    },

    {
        name: '@pollux.add.meraki.network.device',
        displayName: "Add Devices to Existing Networks",
        description: "Allows the user to add devices to existing networks",
        permissions: [
            'pollux.add.network.devices',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
        ]],
    },
    {
        name: '@pollux.swap.meraki.network.device',
        displayName: "Swap Devices on Existing Networks",
        description: "Allows the user to swap devices on existing networks",
        permissions: [
            'pollux.swap.network.device',
        ],
        modulePermissions: [[
            'MERAKI_MAIN:UPDATE',
        ]],
    },
]


export const permissionCategories: PermissionCategory[] = [
    {
        name: "organization",
        displayName: "Organization Management",
        permissionBundles: [
            "@pollux.manage.main.organization.branding",
            "@pollux.manage.main.organization.it_management",
            "@pollux.view.main.organization.integration",
            "@pollux.manage.main.organization.integration",
            "@pollux.view.main.devapikey",
            "@pollux.manage.main.devapikey",
            "@pollux.delete.main.devapikey",
            "@pollux.manage.main.organization.strategy.network.naming",
            "@pollux.manage.main.organization.strategy.location.naming",
            // "@pollux.view.main.uploaded_file",
            // "@pollux.view.main.notifications",
        ]
    },
    {
        name: "users-roles",
        displayName: "Users & Roles",
        permissionBundles: [
            "@pollux.manage.main.user.self",
            "@pollux.view.main.user",
            "@pollux.manage.main.user",
            "@pollux.manage.main.user.password",
            "@pollux.manage.main.user.role",
            "@pollux.delete.main.user",
            "@pollux.view.main.role",
            "@pollux.manage.main.role",
            "@pollux.delete.main.role",
            "@pollux.view.main.invitation",
            "@pollux.manage.main.invitation",
            "@pollux.delete.main.invitation",
        ]
    },
    {
        name: "supportDesk",
        displayName: "Support Desk",
        permissionBundles: [
            "@pollux.view.support_desk.tickets",
            "@pollux.reply.support_desk.tickets",
            "@pollux.view.support_desk.changes",
            "@pollux.reply.support_desk.changes",
            "@pollux.view.support_desk.service_reports",
            "@pollux.manage.support_desk.service_reports",
            "@pollux.delete.support_desk.service_reports",
            "@pollux.view.support_desk.settings",
            "@pollux.manage.support_desk.settings",
        ]
    },
    {
        name: "locations",
        displayName: "Locations",
        permissionBundles: [
            "@pollux.view.location.overview",
            "@pollux.create.location.refit.prestage",
            "@pollux.create.location.refit.phase_2",
            "@pollux.manage.location.location",
            "@pollux.import.location.location",
            "@pollux.delete.location.location",
            "@pollux.view.location.branch",
            "@pollux.manage.location.branch",
            "@pollux.delete.location.branch",
            "@pollux.view.location.type",
            "@pollux.manage.location.type",
            "@pollux.delete.location.type",
            "@pollux.view.location.speedtest",
            // "@pollux.manage.location.speedtest",
        ]
    },
    {
        name: "ipam-blueprints",
        displayName: "IPAM - Blueprints",
        permissionBundles: [
            "@pollux.view.ipam_blueprint.network_range",
            "@pollux.manage.ipam_blueprint.network_range",
            "@pollux.delete.ipam_blueprint.network_range",
            "@pollux.view.ipam_blueprint.vlan_rule",
            "@pollux.manage.ipam_blueprint.vlan_rule",
            "@pollux.delete.ipam_blueprint.vlan_rule",
            "@pollux.view.ipam_blueprint.vlan_rule_action",
            "@pollux.manage.ipam_blueprint.vlan_rule_action",
            "@pollux.delete.ipam_blueprint.vlan_rule_action"
        ]
    },
    {
        name: "merakiGeneral",
        displayName: "Meraki General",
        permissionBundles: [
            "@pollux.view.meraki.client",
            "@pollux.view.meraki.network",
            "@pollux.manage.meraki.network",
            "@pollux.delete.meraki.network",
            "@pollux.view.meraki.subnet",
            "@pollux.manage.meraki.subnet",
            "@pollux.view.meraki.network.vlan",
            "@pollux.view.meraki.network.fixed_ip_assignment",
            "@pollux.manage.meraki.network.fixed_ip_assignment",
            "@pollux.delete.meraki.network.fixed_ip_assignment",
            "@pollux.view.meraki.vpn_status",
            "@pollux.view.meraki.internet_connections",
            "@pollux.view.meraki.cellular_backup",
            "@pollux.manage.meraki.guest_wifi",
            "@pollux.manage.meraki.settings.guest_wifi",
            "@pollux.view.meraki.switchports",
        ]
    },
    {
        name: "merakiDevices",
        displayName: "Meraki Devices",
        permissionBundles: [
            "@pollux.view.meraki.device.all",
            "@pollux.view.meraki.device.router",
            "@pollux.view.meraki.device.switch",
            "@pollux.view.meraki.device.wireless_lan",
            "@pollux.view.meraki.device.sensor",
            "@pollux.view.meraki.device.cellular_gateway",
            "@pollux.view.meraki.device.camera",
            "@pollux.reboot.meraki.device.all",
            "@pollux.reboot.meraki.device.router",
            "@pollux.reboot.meraki.device.switch",
            "@pollux.reboot.meraki.device.wireless_lan",
            "@pollux.reboot.meraki.device.sensor",
            "@pollux.reboot.meraki.device.cellular_gateway",
            "@pollux.reboot.meraki.device.camera",
            "@pollux.view.meraki.camera.snapshot",
            "@pollux.manage.meraki.camera.request_footage",
            "@pollux.add.meraki.network.device",
            "@pollux.swap.meraki.network.device",
            "@pollux.export.meraki.devices_per_contract",
            "@pollux.view.meraki.mxports",
            "@pollux.view.meraki.mx.inspect.static",
            "@pollux.view.meraki.mx.inspect.live",
            "@pollux.manage.meraki.mx"
        ]
    },
    {
        name: "verkada",
        displayName: "Verkada",
        permissionBundles: [
            "@pollux.view.verkada.cameras",
            "@pollux.view.verkada.access",
            "@pollux.view.verkada.sites",
            "@pollux.manage.verkada.cameras.footage_request",
            "@pollux.manage.verkada.cameras.snapshot",
            "@pollux.manage.verkada.access",
            "@pollux.manage.verkada.sites",
        ],
    },
    {
        name: "wyebot",
        displayName: "Wyebot",
        permissionBundles: [
            "@pollux.view.wyebot.sites",
            "@pollux.view.wyebot.sensors",
            "@pollux.view.wyebot.tests",
            "@pollux.manage.wyebot.sites",
            "@pollux.manage.wyebot.sensors",
            "@pollux.manage.wyebot.tests",
            "@pollux.delete.wyebot.tests",
        ],
    },
    {
        name: "rms",
        displayName: "RMS",
        permissionBundles: [
            "@pollux.view.rms.cellular_backup",
        ]
    },
    {
        name: "external_tools",
        displayName: "External Tools",
        permissionBundles: [
            "@pollux.view.external_tools.sim_cards",
            "@pollux.delete.external_tools.sim_cards",
            "@pollux.manage.external_tools.sim_cards.notes",
            "@pollux.delete.external_tools.sim_cards.notes"
        ]
    },
    {
        name: "ipam",
        displayName: "IPAM",
        permissionBundles: [
            "@pollux.view.ipam",
        ]
    },
    {
        name: "documentation",
        displayName: "Documentation",
        permissionBundles: [
            "@pollux.view.location.documentation",
            "@pollux.manage.location.documentation",
            "@pollux.delete.location.documentation",
            "@pollux.view.documentation.procedures",
            "@pollux.manage.documentation.procedures",
            "@pollux.delete.documentation.procedures",
        ]
    }
]
